(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsDataGranularity(
            module.exports
        );

    } else {
        RivalIQ.module('enums');

        enumsDataGranularity(
            RivalIQ.enums
        );
    }

    function enumsDataGranularity(exports) {
        exports.dataGranularity = {
            company: 1,
            presence: 2,
            trends: 3
        };
    }

}());
